import cn from 'classnames';
import { LandingLayout } from 'layouts';
import type { OnboardingTourStep, Profile } from 'models';
import type { ReactNode } from 'react';
import { AxiosErrorHandler, Loading } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useProfileQuery } from 'features/users/queries';
import { Footer, Header } from '../components';
import { useOnboardingTourSteps } from '../queries';

const OnboardingTourLayout = ({
  centeredContent = false,
  contentLeft,
  contentRight,
}: {
  centeredContent?: boolean;
  contentLeft: ((data: { steps: OnboardingTourStep[] }) => ReactNode) | ReactNode;
  contentRight: (data: { steps: OnboardingTourStep[]; viewer: Profile }) => ReactNode;
}) => {
  const { data: viewer, error: profileError, isLoading: isLoadingProfile } = useProfileQuery({ throwOnError: false });
  const { data: steps, error: stepsError, isLoading: isLoadingSteps } = useOnboardingTourSteps({ throwOnError: false });

  return (
    <LandingLayout
      className="onboarding-tour-layout"
      contentLeft={
        typeof contentLeft === 'function'
          ? // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
            isLoadingSteps || !steps
            ? undefined
            : contentLeft({ steps })
          : contentLeft
      }
      contentRight={
        <AxiosErrorHandler error={profileError ?? stepsError}>
          {isLoadingSteps || !steps || isLoadingProfile || !viewer ? (
            <Loading />
          ) : (
            <div
              className={cn('onboarding-tour-layout__content', {
                'onboarding-tour-layout__content--full-height': !centeredContent,
              })}
            >
              {contentRight({ steps, viewer })}
            </div>
          )}
        </AxiosErrorHandler>
      }
      footer={<Footer />}
      header={<Header items={[]} />}
    />
  );
};

export default OnboardingTourLayout;
